import React, { Component } from 'react';
import { motion } from 'framer-motion';
export function WhatsAppFloat() {
  const phone = '19179431412'; // US country code + number
  const message = encodeURIComponent('Hola Riam Beauty Studio, me gustaría agendar una cita.');
  const href = `https://wa.me/${phone}?text=${message}`;
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" aria-label="Chatea con nosotros por WhatsApp" initial={{
    opacity: 0,
    scale: 0,
    y: 20
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 1.2,
    type: 'spring',
    stiffness: 200
  }} whileHover={{
    scale: 1.08
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60] group" data-id="element-371">
      {/* Pulsing rings */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" data-id="element-372" />
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-pulse" data-id="element-373" />

      {/* Main button */}
      <div className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-lg transition-shadow duration-300 group-hover:shadow-2xl" style={{
      boxShadow: '0 6px 20px rgba(37, 211, 102, 0.45), 0 0 0 2px rgba(232, 201, 122, 0.4)'
    }} data-id="element-374">
        {/* WhatsApp glyph (inline SVG for perfect fidelity) */}
        <svg viewBox="0 0 32 32" className="w-7 h-7 md:w-8 md:h-8 fill-white" aria-hidden="true" data-id="element-375">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.044 2.262v.114c-.015.99.472 1.977 1.198 2.84 1.36 1.61 2.875 2.916 4.683 3.703.42.187.733.32 1.117.43.43.13.83.108 1.143.108.493 0 1.085-.4 1.4-.7.2-.187.286-.5.286-.685 0-.13-.043-.244-.072-.358-.072-.27-1.272-.83-1.46-.83zM16.288 6.5c-5.232 0-9.485 4.252-9.485 9.485 0 1.643.43 3.265 1.246 4.692L6.5 25.5l4.96-1.514a9.5 9.5 0 0 0 4.828 1.314c5.232 0 9.485-4.253 9.485-9.486s-4.253-9.485-9.485-9.485zm0 17.346a7.857 7.857 0 0 1-4.005-1.099l-.286-.172-2.974.91.9-2.913-.187-.3a7.85 7.85 0 0 1-1.202-4.187c0-4.342 3.413-7.86 7.754-7.86s7.756 3.518 7.756 7.86c0 4.34-3.415 7.76-7.756 7.76z" data-id="element-376" />
        </svg>
      </div>

      {/* Hover tooltip */}
      <span className="hidden md:block absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-riam-black border border-riam-gold/30 text-riam-gold-light text-xs font-sans tracking-widest uppercase px-3 py-2 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-377">
        Chatea con nosotros
      </span>
    </motion.a>;
}